"use client";

import { TCollabComment } from "@hocuspocus/provider";
import { DateTime } from "luxon";
import { getInitials } from "../../lib/string";
import { Avatar, AvatarFallback } from "../ui/avatar";

interface WriterThreadCommentProps {
  comment: TCollabComment;
}

export const WriterThreadComment = ({ comment }: WriterThreadCommentProps) => {
  const userName: string = comment.data?.userName || "Unknown User";

  const createdAt = comment.createdAt
    ? new Date(comment.createdAt)
    : new Date();
  const timeAgo = DateTime.fromJSDate(createdAt).toRelative();

  return (
    <div className="flex gap-3 border-b border-gray-100 p-3 last:border-b-0">
      <Avatar className="h-8 w-8 flex-shrink-0">
        <AvatarFallback className="bg-blue-100 text-xs text-blue-600">
          {getInitials(userName)}
        </AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1">
        <div className="mb-1 flex items-center gap-2">
          <span className="text-sm font-medium text-gray-900">{userName}</span>
          <span
            className="text-xs text-gray-500"
            title={createdAt.toLocaleString()}
          >
            {timeAgo}
          </span>
        </div>
        <div className="text-sm break-words whitespace-pre-wrap text-gray-700">
          {comment.content}
        </div>
      </div>
    </div>
  );
};
